module.exports = __webpack_public_path__ + "static/media/yellow_bike.574c9805.png";